/**
 * @license
 * Copyright 2019 Xunlei Network.
 *
 * @description
 * Tbc native api delegate.
 */
'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TBCNativeApi = exports.TBCNativeCore = void 0;
var sdk_1 = require("@xbase/sdk");
var utils_1 = require("./common/utils");
var interface_1 = require("./interface");
/**
 * TBC native core.
 */
var TBCNativeCore = /** @class */ (function () {
    function TBCNativeCore() {
    }
    Object.defineProperty(TBCNativeCore.prototype, "native", {
        /**
         * native.
         */
        get: function () {
            var windowAny = window;
            return windowAny.native;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * On.
     * @param {string | number} type
     * @param {NativeCoreListener} listener
     * @return {this}
     */
    TBCNativeCore.prototype.on = function (type, listener) {
        // eslint-disable-next-line new-cap
        this.native.AttachNativeEvent(type, function () {
            if (typeof listener === 'function') {
                listener();
            }
        });
        return this;
    };
    /**
     * Off.
     * @param {string | number} type
     * @param {NativeCoreListener} listener
     * @return {this}
     */
    TBCNativeCore.prototype.off = function (type, listener) {
        return this;
    };
    /**
     * Check if support CheckFunction.
     * @return {boolean}
     */
    TBCNativeCore.prototype.supportCheckFuncion = function () {
        return typeof this.native.CheckNativeFunction === 'function';
    };
    /**
     * Check function.
     * @param {string} functionName
     * @return {Promise<NativeCoreCheckFunctionResponse>}
     */
    TBCNativeCore.prototype.checkFunction = function (functionName) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.supportCheckFuncion() && _this.native.CheckNativeFunction) {
                // eslint-disable-next-line new-cap
                _this.native.CheckNativeFunction(functionName, function (response) {
                    // 0表示存在，1表示不存在
                    resolve({
                        exist: response === 0,
                    });
                });
            }
            else {
                var naError = {
                    error: sdk_1.ErrorType.NOT_FOUND,
                };
                reject(naError);
            }
        });
    };
    /**
     * Call.
     * @param {string} functionName
     * @param {any[]} args
     * @return {Promise<T>}
     */
    TBCNativeCore.prototype.call = function (functionName) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return new Promise(function (resolve, reject) {
            var _a;
            // eslint-disable-next-line new-cap
            (_a = _this.native).CallNativeFunction.apply(_a, __spreadArrays([functionName], args, [function (errorCode, returnValue) {
                    var naError = _this._toNAError(errorCode);
                    if (naError) {
                        reject(naError);
                    }
                    else {
                        resolve(returnValue);
                    }
                }]));
        });
    };
    /**
     * To native error.
     * @param {number} errorCode
     * @return {ResponseError | null}
     */
    TBCNativeCore.prototype._toNAError = function (errorCode) {
        var naError = null;
        if (typeof errorCode === 'number' && errorCode != 0) {
            switch (errorCode) {
                case 1:
                    naError = {
                        error: sdk_1.ErrorType.UNKNOWN,
                    };
                    break;
                case 2:
                    naError = {
                        error: sdk_1.ErrorType.NOT_FOUND,
                    };
                    break;
                case 3:
                    naError = {
                        error: sdk_1.ErrorType.INVALID_ARGUMENT,
                    };
                    break;
                default:
                    naError = {
                        error: sdk_1.ErrorType.UNKNOWN,
                    };
                    break;
            }
        }
        return naError;
    };
    return TBCNativeCore;
}());
exports.TBCNativeCore = TBCNativeCore;
/**
 * TBC native core helper.
 */
var TBCNativeCoreHelper = /** @class */ (function () {
    /**
     * constructor.
     * @param {TBCNativeCore} native
     */
    function TBCNativeCoreHelper(native) {
        this._native = native;
    }
    /**
     * Get TBC data.
     * @param {string} type
     * @param {string} key
     */
    TBCNativeCoreHelper.prototype.getTBCData = function (type, key) {
        return __awaiter(this, void 0, void 0, function () {
            var callNativeFunctionResponse, value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._native.call('LoadLoginData', type, key)];
                    case 1:
                        callNativeFunctionResponse = _a.sent();
                        value = null;
                        try {
                            if (typeof callNativeFunctionResponse === 'string' &&
                                callNativeFunctionResponse.length > 0) {
                                value = JSON.parse(callNativeFunctionResponse);
                            }
                        }
                        catch (error) {
                            value = null;
                        }
                        return [2 /*return*/, value];
                }
            });
        });
    };
    /**
     * Set TBC data.
     * @param {string} type
     * @param {string} key
     * @param {any} value
     */
    TBCNativeCoreHelper.prototype.setTBCData = function (type, key, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._native.call('SaveLoginData', type, key, JSON.stringify(value))];
            });
        });
    };
    return TBCNativeCoreHelper;
}());
/**
 * TBC native api.
 */
var TBCNativeApi = /** @class */ (function (_super) {
    __extends(TBCNativeApi, _super);
    /**
     * constructor
     */
    function TBCNativeApi() {
        var _this = _super.call(this) || this;
        _this._nativeCore = new TBCNativeCore();
        _this._nativeCoreHelper = new TBCNativeCoreHelper(_this._nativeCore);
        return _this;
    }
    Object.defineProperty(TBCNativeApi.prototype, "nativeCore", {
        /**
         * Get native core.
         */
        get: function () {
            return this._nativeCore;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Init.
     */
    TBCNativeApi.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.nativeCore.on('OnUserLogin', function () {
                    _this.emit('login');
                });
                this.nativeCore.on('OnUserLogout', function () {
                    _this.emit('logout');
                });
                return [2 /*return*/];
            });
        });
    };
    /**
     * Get app info.
     */
    TBCNativeApi.prototype.getAppInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var appInfo, runTask1, runTask2, runTask3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        appInfo = {};
                        runTask1 = function () { return __awaiter(_this, void 0, void 0, function () {
                            var appInfoData, error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, this._nativeCoreHelper.getTBCData('memory', 'appinfo')];
                                    case 1:
                                        appInfoData = _a.sent();
                                        if (appInfoData) {
                                            if (appInfoData.appid !== undefined && appInfoData.appid !== null) {
                                                appInfo.appId = appInfoData.appid;
                                            }
                                            if (appInfoData.package !== undefined &&
                                                appInfoData.package !== null) {
                                                appInfo.noHostAppName = appInfoData.package;
                                                appInfo.appName = 'PC-' + appInfo.noHostAppName;
                                            }
                                        }
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_1 = _a.sent();
                                        console.error(error_1);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); };
                        runTask2 = function () { return __awaiter(_this, void 0, void 0, function () {
                            var deviceSignData, deviceId, error_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, this._nativeCoreHelper.getTBCData('memory', 'deviceid')];
                                    case 1:
                                        deviceSignData = _a.sent();
                                        if (deviceSignData &&
                                            deviceSignData.id !== undefined &&
                                            deviceSignData.id !== null) {
                                            appInfo.deviceSign = deviceSignData.id;
                                        }
                                        deviceId = utils_1.deviceSign2DeviceId(appInfo.deviceSign);
                                        if (deviceId) {
                                            appInfo.deviceId = deviceId;
                                        }
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_2 = _a.sent();
                                        console.error(error_2);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); };
                        runTask3 = function () { return __awaiter(_this, void 0, void 0, function () {
                            var peerIdData, error_3;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, this.nativeCore.call('GetDeviceID')];
                                    case 1:
                                        peerIdData = _a.sent();
                                        if (peerIdData &&
                                            typeof peerIdData === 'string' &&
                                            peerIdData.length > 0) {
                                            appInfo.peerId = peerIdData;
                                        }
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_3 = _a.sent();
                                        console.error(error_3);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); };
                        return [4 /*yield*/, Promise.all([runTask1(), runTask2(), runTask3()])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, appInfo];
                }
            });
        });
    };
    /**
     * Get session user info.
     */
    TBCNativeApi.prototype.getSessionUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userInfoData, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._nativeCoreHelper.getTBCData('memory', 'userinfo')];
                    case 1:
                        userInfoData = _a.sent();
                        result = {};
                        if (userInfoData) {
                            if (userInfoData.sessionid != undefined) {
                                result.sessionId = userInfoData.sessionid;
                            }
                            if (userInfoData.userid != undefined) {
                                result.userId = userInfoData.userid;
                            }
                            if (userInfoData.loginkey != undefined) {
                                result.loginKey = userInfoData.loginkey;
                            }
                            if (userInfoData.usernick != undefined) {
                                result.userNick = userInfoData.usernick;
                            }
                            if (userInfoData.usrname != undefined) {
                                result.userName = userInfoData.usrname;
                            }
                            if (userInfoData.score != undefined) {
                                result.score = userInfoData.score;
                            }
                            if (userInfoData.upgrade != undefined) {
                                result.upgrade = userInfoData.upgrade;
                            }
                            if (userInfoData.order != undefined) {
                                result.order = userInfoData.order;
                            }
                            if (userInfoData.usernewno != undefined) {
                                result.userNewno = userInfoData.usernewno;
                            }
                            if (userInfoData.usertype != undefined) {
                                result.userType = userInfoData.usertype;
                            }
                            if (userInfoData.state != undefined) {
                                result.state = userInfoData.state;
                            }
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Set login info.
     * @param {LoginInfo} loginInfo
     */
    TBCNativeApi.prototype.setLoginInfo = function (loginInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {
                            userid: '',
                            sessionid: '',
                            uName: '',
                            loginkey: '',
                            xl_autologin: false,
                            loginType: 5,
                        };
                        if (loginInfo) {
                            if (loginInfo.loginKey) {
                                data.loginkey = loginInfo.loginKey;
                            }
                            data.xl_autologin = loginInfo.autoLogin === true;
                            if (loginInfo.userId !== undefined && loginInfo.userId !== null) {
                                data.userid = loginInfo.userId;
                            }
                            if (loginInfo.sessionId !== undefined && loginInfo.sessionId !== null) {
                                data.sessionid = loginInfo.sessionId;
                            }
                            if (typeof data.userid === 'string' &&
                                data.userid.length > 0 &&
                                typeof data.sessionid === 'string' &&
                                data.sessionid.length > 0) {
                                data.loginType = 5;
                            }
                            else {
                                data.loginType = '1';
                            }
                        }
                        return [4 /*yield*/, this._nativeCoreHelper.setTBCData('memory', 'userinfo', data)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Show login window.
     */
    TBCNativeApi.prototype.showLoginWindow = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nativeCore.call('ShowLoginDlg')];
            });
        });
    };
    /**
     * 设置oauth退出页
     * 迅雷X第一版本接入的旧方案为：
     * 根据clientId值，储存各个业务的uri，并于退出时调用各个uri页面（通过设置clientId为一个特殊字符串来处理登录中心的退出uri）
     * 迅雷x第二版本接入的新方案为：
     * 储存登录中心的退出的uri，并于退出时调用uri页面
     * 迅雷x最终接入的新方案为：
     * 在迅雷x第二版本接入的方案的基础上，支持客户端设置默认oauth.html的sign out页面
     * @param {SetOAuthSignOutURIParams} params
     */
    TBCNativeApi.prototype.setOAuthSignOutURI = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var setXbaseLogoutUrlParams;
            return __generator(this, function (_a) {
                setXbaseLogoutUrlParams = {};
                switch (params.version) {
                    case 1:
                        setXbaseLogoutUrlParams.clientId = params.clientId;
                        setXbaseLogoutUrlParams.url = params.signOutURI;
                        break;
                    case 2:
                        setXbaseLogoutUrlParams.url = params.signOutURI;
                        break;
                    default:
                        break;
                }
                return [2 /*return*/, this.nativeCore.call('FireLoginEvent', 'setXbaseLogoutUrl', JSON.stringify(setXbaseLogoutUrlParams))];
            });
        });
    };
    return TBCNativeApi;
}(interface_1.NativeApi));
exports.TBCNativeApi = TBCNativeApi;
//# sourceMappingURL=tbc-native-api.js.map